module.exports = __webpack_public_path__ + "img/biei.88c288a1.png";